<!-- Copyright (c) 2025 Digital Systems (M) Sdn. Bhd. -->

<template>
  <div class="smkproduct-main">
    <Menus :menu="menus" @menuClicked="handleMenuClick" />
    <div class="right-container">
      <TableBox
        title="All SMK Product"
        :tableData="SMKProductData"
        :selectedRow.sync="selectedSMKProduct"
        v-if="reloadTable"
      />
    </div>
    <PopupEntry
      v-if="popupEntryShow"
      :show.sync="popupEntryShow"
      :title="popUpTitle"
      :viewMode="viewMode"
      @save="saveClick"
    >
      <div class="popup-top-section">
        <InputQuery
          placeholder="Customer Code"
          :items="customerData"
          itemKey="custNumberAndName"
          :selectedObject.sync="selectedCustomer"
          :isRequired="true"
          :isDisabled="viewMode || popUpAction === 'E'"
          :errorMessage="customerErrMsg"
          :tableBoxHideColumns="['custNumberAndName']"
        />
        <InputQuery
          placeholder="Product Code"
          :items="SMKProductInputQueryData"
          itemKey="Product Code"
          :selectedObject.sync="selectedSMKProductInputQuery"
          :isRequired="true"
          :isDisabled="viewMode || popUpAction === 'E'"
          :errorMessage="SMKProductInputQueryErrMsg"
          :allowFreeText="true"
          :search.sync="SMKProductInputQueryText"
        />

        <RemarksBox
          title="Product Description"
          :text.sync="productDescriptionTextArea"
          :isDisabled="viewMode"
          :maxLength="70"
        />
        <Input placeholder="Uplift (%)" :inputValue.sync="upLift" validator="decimal,3,2" :isDisabled="viewMode" />
        <Dropdown
          :items="upLiftQualifier"
          itemKey="fullIncoTerm"
          :isDisabled="viewMode"
          :selectedObject.sync="selectedUpLiftQualifier"
          placeholder="Uplift Qualifier"
        />
        <Input placeholder="Veterinary Permit" :inputValue.sync="vPermit" :isDisabled="viewMode" />
        <Input placeholder="A.P #" :inputValue.sync="apNo" :isDisabled="viewMode" />
        <DateTimePicker
          placeholder="A.P Expiry Date"
          :value.sync="apExpiryDate"
          :showTime="false"
          :isDisabled="viewMode"
        />
      </div>
    </PopupEntry>
  </div>
</template>

<script>
export default {
  components: {},
  computed: {},
  data: function () {
    return {
      menus: [
        {
          title: 'Create SMK Product',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-add-new-50.png',
          key: 'MnuNew',
          visible: true,
          enabled: true,
        },
        {
          title: 'Edit SMK Product',
          icon: 'https://dsmlib.logistics.systems/Icons/icons8-edit-64%20(1).png',
          key: 'MnuEdit',
          visible: true,
          enabled: true,
        },
        {
          title: 'Delete SMK Product',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-reduce-50.png',
          key: 'MnuDelete',
          visible: false,
          enabled: true,
        },
        {
          title: 'View SMK Product',
          icon: 'https://dsmlib.logistics.systems/Icons/icons8-view-64.png',
          key: '',
          visible: true,
          enabled: true,
        },
      ],
      // Table + Dropdown Data
      SMKProductData: [],
      selectedSMKProduct: [],
      reloadTable: true,

      // Popup data
      popupEntryShow: false,
      popUpTitle: '',
      viewMode: true,
      popUpAction: '',

      customerData: null,
      selectedCustomer: null,
      customerErrMsg: '',

      selectedSMKProductInputQuery: null,
      SMKProductInputQueryErrMsg: '',
      SMKProductInputQueryText: '',
      SMKProductInputQueryData: [],

      productDescriptionTextArea: '',
      upLift: null,

      upLiftQualifier: null,
      selectedUpLiftQualifier: null,

      vPermit: '',
      apNo: '',
      apExpiryDate: null,
    };
  },
  props: {},
  methods: {
    handleMenuClick: async function (menu) {
      this.resetFields();
      switch (menu.title) {
        case 'View SMK Product': {
          this.viewMode = true;
          this.popUpTitle = 'View SMK Product';
          this.popUpAction = 'V';
          if (this.selectedSMKProduct.length == 0 && this.popUpAction !== 'N') {
            this.$showAlert('error', 'No SMK Product Selected', 'Please select a record to view');
            return;
          }
          await this.populatePopUp();
          break;
        }

        case 'Edit SMK Product': {
          this.viewMode = false;
          this.popUpTitle = 'Edit SMK Product';
          this.popUpAction = 'E';
          if (this.selectedSMKProduct.length == 0 && this.popUpAction !== 'N') {
            this.$showAlert('error', 'No SMK Product Selected', 'Please select a record to view');
            return;
          }
          await this.populatePopUp();
          break;
        }
        case 'Create SMK Product': {
          this.viewMode = false;
          this.popUpTitle = 'Create SMK Product';
          this.popUpAction = 'N';
          this.popupEntryShow = true;
          break;
        }
        case 'Delete SMK Product': {
          this.popUpAction = 'D';
          if (this.selectedSMKProduct.length == 0) {
            this.$showAlert('error', 'No SMK Product Selected', 'Please select a record to view');
            return;
          }
          const deleting = await this.$showAlert(
            'warning',
            'Delete SMK Product',
            `Are you sure you want to delete this SMK Product?`,
            [
              { text: 'Delete', textColor: 'white', color: 'red' },
              { text: 'Cancel', textColor: 'black', color: 'lightgray' },
            ],
          );

          if (deleting == 'Cancel') {
            return;
          }

          const jsonBody = {
            cu_number: this.selectedSMKProduct[0]['Customer Code'],
            productcode: this.selectedSMKProduct[0]['Product Code'],
            seqno: this.selectedSMKProduct[0]['seqno'],
            actionflag: 'D',
          };
          await this.$apiCallV2('/SMKProduct/SaveSMKProduct', jsonBody);

          await this.reloadTableFunc();
        }
      }
    },
    async populatePopUp() {
      this.popupEntryShow = true;
      this.selectedCustomer = this.customerData.getSelected(
        this.selectedSMKProduct[0]['Customer Code'],
        'Customer Code',
      );
      this.selectedSMKProductInputQuery = this.selectedSMKProduct.getSelected(
        this.selectedSMKProduct[0]['Product Code'],
        'Product Code',
      );
      const jsonBody = {
        cu_number: this.selectedCustomer['Customer Code'],
        productcode: this.selectedSMKProduct[0]['Product Code'],
        seqno: this.selectedSMKProduct[0]['seqno'],
      };
      const data = await this.$apiCallV2('/SMKProduct/GetSMKProductDetails', jsonBody);
      this.productDescriptionTextArea = data[0]['Product Name'];
      this.upLift = String(data[0]['uplift']);
      this.selectedUpLiftQualifier = this.upLiftQualifier.getSelected(data[0]['UpliftQ'], 'Incoterm');
      this.vPermit = data[0]['VPermit'];
      this.apNo = data[0]['APNo'];
      this.apExpiryDate = new Date(data[0]['ApExpiryDate']);
    },
    async reloadTableFunc() {
      await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'SMKPRODUCT' }).then((result) => {
        this.SMKProductData = result;
      });
      this.reloadTable = false;
      this.$nextTick(() => {
        this.reloadTable = true;
        this.selectedSMKProduct = [];
      });
    },
    resetFields() {
      this.selectedCustomer = null;
      this.selectedSMKProductInputQuery = null;
      this.productDescriptionTextArea = '';
      this.upLift = '';
      this.selectedUpLiftQualifier = null;
      this.vPermit = '';
      this.apNo = '';
      this.apExpiryDate = null;
      this.customerErrMsg = '';
      this.SMKProductInputQueryErrMsg = '';
      this.SMKProductInputQueryText = '';
    },
    async saveClick() {
      if (this.selectedCustomer === null) {
        this.customerErrMsg = 'Fill in customer field';
      }
      if (this.SMKProductInputQueryText === '') {
        this.SMKProductInputQueryErrMsg = 'Fill in SMK Product Code';
      }
      const SMKProductCode = this.SMKProductInputQueryText;
      const seqnum = this.SMKProductData.filter(
        (smkproduct) =>
          SMKProductCode === smkproduct['Product Code'] &&
          this.selectedCustomer['Customer Code'] === smkproduct['Customer Code'],
      );
      const seq = this.popUpAction === 'N' ? seqnum.length + 1 : seqnum.length;
      const jsonBody = {
        productcode: SMKProductCode, //Compulsory field
        seqno: seq,
        productname: this.productDescriptionTextArea,
        uplift: this.upLift ? Number(this.upLift) : '',
        upliftq: this.selectedUpLiftQualifier?.['Incoterm'] ?? '',
        vpermit: this.vPermit,
        apno: this.apNo,
        apexpirydate: this.apExpiryDate?.formatString('yyyy-MM-dd HH:mm') ?? '',
        cu_number: this.selectedCustomer?.['Customer Code'], //Compulsory field
      };

      jsonBody['actionflag'] = this.popUpAction;
      await this.$apiCallV2('/SMKProduct/SaveSMKProduct', jsonBody);

      await this.reloadTableFunc();
      this.viewMode = true;
      this.popUpTitle = 'View SMK Product';
      this.popUpAction = 'V';
    },
    async sasControlFunction() {
      this.$fullscreenLoading('Checking Security Access');
      const sasControl = await this.$apiCallV2(`/SASControl/GetSASControlAccess?system=MASTER&page=SMK Product`);
      sasControl.forEach((k) => {
        //key in menu same as control value from api
        const selectedMenu = this.menus.find((m) => m['key'] == k['Control']);
        if (selectedMenu) {
          selectedMenu[k['Properties'].toLowerCase()] = k['PropertiesValue'] == 'True';
        }
      });
      this.$fullscreenLoading('');
    },
  },
  async mounted() {
    await this.sasControlFunction();
    this.$fullscreenLoading('Getting Data');
    const mountedPromises = [];
    let mountedPromisesFulfilledCount = 0;
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'SHIPPERCONSIGNEE' }).then((result) => {
        this.customerData = result;
        this.customerData.forEach((customer) => {
          customer.custNumberAndName = `${customer['Customer Code']} - ${customer['Customer Name']}`;
        });
        this.$topLoading(++mountedPromisesFulfilledCount / mountedPromises.length);
      }),
    );
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'SMKPRODUCT' }).then((result) => {
        this.SMKProductData = result;
        this.$topLoading(++mountedPromisesFulfilledCount / mountedPromises.length);
      }),
    );
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'SMKPRODUCTDROPDOWN' }).then((result) => {
        this.SMKProductInputQueryData = result;
        this.$topLoading(++mountedPromisesFulfilledCount / mountedPromises.length);
      }),
    );
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'INCOTERMS' }).then((result) => {
        this.upLiftQualifier = result;
        this.upLiftQualifier.forEach((incoterm) => {
          incoterm.fullIncoTerm = `${incoterm['Incoterm']} - ${incoterm['Incoterm Desc']}`;
        });
        this.$topLoading(++mountedPromisesFulfilledCount / mountedPromises.length);
      }),
    );
    await Promise.allSettled(mountedPromises);
    this.$fullscreenLoading();
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';
.smkproduct-main {
  padding: 5px 45px;
  font-size: 12px;
  display: flex;
  height: 100%;
  > .right-container {
    background-color: white;
    padding: 5px;
    border-radius: 5px;
    width: 100%;
    margin-left: 5px;
    overflow: hidden;
  }
  .popup-entry-container {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;

    > .popup-top-section {
      display: flex;
      flex-direction: column;
      padding-bottom: 5px;
    }
  }
}
</style>
